/**
 * 用户、企业相关接口
 */
const url = '/checkmall-user/api'
export default {
    //获取验证码
    captcha: url + "/auth/captcha.jpg",
    //获取验证码
    captchaVerification: url + "/auth/captchaVerification",
    // 用户登录
    login: url + "/auth/user/login",
    // 无登录发送验证码 基于手机号
    sendCaptchaByPhone: url + "/auth/sendCaptchaByPhone",
    // 用户注册
    register: url + "/auth/user/register",
    // 用户密码重置接口
    resetPw: url + "/auth/user/reset",
    // 获取企业列表
    deptList: url + "/dept/list",
    // 新增企业
    addDept: url + "/dept/addData",
    // 更新企业
    updateDept: url + "/dept/updateData",
    // 删除企业
    deleteDept: url + "/dept/deleteData",
    // 通过id获取企业
    deptById: url + "/dept/deptDetail",
    // 开票信息新增
    tickAdd: url + "/invoice/addData",
    // 开票信息list
    tickList: url + "/invoice/list",
    // 开票信息修改
    tickUpdate: url + "/invoice/updateData",
    // 开票信息删除
    tickDel: url + "/invoice/deleteData",
    // 开票信息不分页
    tickAll: url + "/invoice/allList",
    // 用户手机验证码登录
    captchaLogin: url + "/auth/user/loginByPhone",
    // 更改个人信息
    updateUser:url + '/auth/user/uUpdateUser',
    // 查询已审核企业
    searchDeptList:url + '/dept/searchOtherDeptList',
    // 获取用户信息
    userInfo:url + '/consumer/user/detail',
    // 修改用户信息
    uUpdateUser:url + '/auth/user/uUpdateUser',
    // 账号管理列表
    userList:url + '/consumer/user/list',
    // 账号管理--删除
    cancelReveal:url + '/consumer/user/cancelReveal',
    // 账号管理--审核
    auditUser:url + '/consumer/user/audit',
    // 在线咨询
    sendConsult:url + '/dept/sendConsult',
    // 咨询类型
    getSaleUserList:url + '/dept/getSaleUserList',
    // 单点登录
    fbcLogin:url + '/auth/fbc/login',
    // 退出登录
    logout:url + '/auth/user/logout'
}